import createRulesObject from '@/utils/functions/tasklist/createRulesObject';
import { Select } from 'alurkerja-ui';
import classNames from 'classnames';
import { Controller } from 'react-hook-form';

export const InputSelectVariable = ({ fieldSpec, taskData, setValue, control }: any) => {
  const rulesObject = createRulesObject(fieldSpec);

  const getSelectOptions = () => {
    if (!taskData.variables) {
      console.error('taskData.variables is undefined');
      return [];
    }

    const variables = taskData.variables[fieldSpec.properties.VARIABLE];

    if (!variables) return [];

    return variables.map((variable: any) => {
      return {
        label: variable[fieldSpec.properties.OPTION_LABEL],
        value: variable[fieldSpec.properties.OPTION_KEY],
      };
    });
  };

  return (
    <div>
      <label
        className={classNames('font-medium', {
          'after:content-["*"] after:text-red-400 after:text-sm': fieldSpec.constraints?.required,
        })}
        htmlFor={fieldSpec.name}
      >
        {fieldSpec.label}
      </label>

      <Controller
        name={fieldSpec.name}
        control={control}
        rules={rulesObject}
        render={({ fieldState }) => {
          return (
            <>
              <Select onChange={(e: any) => setValue(fieldSpec.name, e.value)} options={getSelectOptions()}></Select>
              {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
            </>
          );
        }}
      ></Controller>
    </div>
  );
};
